export const LOGIN_ROUTE = '/entrar';
export const SIGN_UP_ROUTE = '/cadastrar';
export const ACCOUNT_SETUP_ROUTE = '/registrar';
export const API_LOGIN_PATH = '/api/login';
export const API_LOGOUT_PATH = '/api/logout';
export const HOME_ROUTE = '/';
export const PASSWORD_RESET_ROUTE = '/recuperar-senha';
export const TERMS_ROUTE = '/termos-de-uso';
export const ADMIN_DASHBOARD_ROUTE = '/admin';

export const CLIENT_INITIAL_LIMIT = 10_000; // R$ 10.000,00
export const MINIMUM_DEPOSIT_AMOUNT = 1.0; // R$ 1,00
